import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import MuiTooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { Padding } from '@mui/icons-material';

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <MuiTooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
    backgroundColor: 'transparent',
    color: '#f7fcff',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f7fcff',
    color: '#272727',
    maxWidth: 200,
    fontSize: theme.typography.pxToRem(14),
    border: '1px solid #a4d1f0',
    borderRadius: '8px',
    padding: '12px',
  },
}));

const Tooltip = () => {
  return (
    <>
      <HtmlTooltip
        title={
          <React.Fragment>
            <div>{"Created by - Mohammad Jamaluddin"}</div> 
            <div>{"Last edited by - String"}</div>
            <div>{"Last edited at - Timestamp"}</div>
            <div>{"Last view by - String"}</div>
            <div>{"Last view at - Timestamp"}</div>
            <Typography style={{marginTop: '10px'}}>Modified Changes</Typography>
            <div>{"Service Fees"}</div> 
            <div>{"Old value & New Value"}</div> 
            <div>{"Timestamp"}</div> 
          </React.Fragment>
        }
        placement="bottom-end"
      >
        <Typography><InfoOutlineIcon /></Typography>
      </HtmlTooltip>
    </>
  )
}

export default Tooltip
